import { isActiveSubscriptionStatus } from '#pplx/frontend/auth/subscriptionStatus.js';
import { normalizeSubscriptionTier } from '#pplx/frontend/auth/subscriptionTier.js';
import { useSession } from '#pplx/frontend/auth/useSession.js';
import { useMemo } from 'react';
export function useIsSubscribed() {
    const { session } = useSession();
    const subscriptionStatus = session?.user?.subscription_status ?? 'none';
    const isSubscriptionActive = isActiveSubscriptionStatus(subscriptionStatus);
    const userSubscriptionTier = session?.user?.subscription_tier;
    const subscriptionTier = userSubscriptionTier === 'basic' && session?.user?.subscription_source !== 'enterprise'
        ? 'basic'
        : normalizeSubscriptionTier(userSubscriptionTier);
    const isPro = isSubscriptionActive && (subscriptionTier === 'pro' || !subscriptionTier);
    const isMax = isSubscriptionActive && subscriptionTier === 'max';
    const isViewer = isSubscriptionActive && (subscriptionTier === 'viewer' || subscriptionTier === 'basic');
    const hasAccessToProFeatures = isPro || isMax;
    const subscriptionSource = isSubscriptionActive ? session?.user?.subscription_source : 'none';
    const isEnterprise = isSubscriptionActive && subscriptionSource === 'enterprise';
    const isEnterprisePro = isEnterprise && (subscriptionTier === 'pro' || !subscriptionTier);
    const isEnterpriseMax = isEnterprise && subscriptionTier === 'max';
    return useMemo(() => ({
        isPro,
        isMax,
        isViewer,
        isBasic: isViewer,
        hasAccessToProFeatures,
        hasActiveSubscription: isSubscriptionActive,
        subscriptionSource,
        subscriptionStatus,
        subscriptionTier,
        isEnterprise,
        isEnterprisePro,
        isEnterpriseMax,
    }), [
        hasAccessToProFeatures,
        isMax,
        isPro,
        isViewer,
        isSubscriptionActive,
        subscriptionSource,
        subscriptionStatus,
        subscriptionTier,
        isEnterprise,
        isEnterprisePro,
        isEnterpriseMax,
    ]);
}
//# sourceMappingURL=useIsSubscribed.js.map